import { v5 as uuidv5 } from "uuid";

const ACCRUAL_ROW_LINE_ID_NAMESPACE = "f47ac10b-58cc-4372-a567-0e02b2c3d479";

export function createAccrualImporterRowLineId({
    scopeId,
    rowId,
}: {
    scopeId: string;
    rowId: string;
}): string {
    return uuidv5(
        `accrual-importer-row:${scopeId}:${rowId}`,
        ACCRUAL_ROW_LINE_ID_NAMESPACE,
    );
}
